module.exports = __webpack_public_path__ + "img/Freundchen.6075f749.jpg";